export default __webpack_public_path__ + "static/media/ismo_updated.5a6b20cf.svg";